var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.currentDamSelectedId)?[_c('ProfileContainer'),_c('CarouselGalleryZoomer')]:_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('b-spinner',{staticClass:"m-5",attrs:{"variant":"primary"}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }